export const formatString = (str: string) =>
  str?.replace(/([ .*+?^=!:${}()|\\/\\])/g, "");
